module.exports = __webpack_public_path__ + "static/media/Thumb_1920x384_DONNiagara_v1.856f4bb9.jpg";